module.exports = __webpack_public_path__ + "img/img_article5_item_1@2x.af69e7fb.png";